import { jsx as _jsx } from "react/jsx-runtime";
import { businessEmojis } from "@/common/emojis";
import { assert } from "@/common/assert";
import { formatImageUrl } from "@/common/utils";
import { ImageSizeTypeEnum } from "@/apis/model/ImageSizeTypeEnum";
export default function ChatBizEmojiMessageItem(props) {
  var key = "";
  var src = "";
  var height;
  var width;
  var urlKey = props.message.customAttrs.EMOTION_URL_KEY;

  if (!urlKey) {
    key = props.message.customAttrs.EMOTION_PATH_KEY;
    assert(key, "gotta have key for biz emoji without urlKey");
    var emoji = businessEmojis[key];
    assert(emoji, "biz emoji not found for key: " + key);
    src = emoji.imgPath;
  }

  if (urlKey) {
    key = "business";
    var widthAttr = props.message.customAttrs.EMOTION_WIDTH_KEY;
    assert(widthAttr, "width attr falsy");
    width = widthAttr <= 500 ? widthAttr / 2 : widthAttr / 6;
    var heightAttr = props.message.customAttrs.EMOTION_HEIGHT_KEY;
    assert(heightAttr, "height attr falsy");
    height = heightAttr <= 500 ? heightAttr / 2 : heightAttr / 6;
    src = formatImageUrl(urlKey, ImageSizeTypeEnum.Thumbnail200whFit);
  }

  return _jsx("img", {
    src: src,
    height: height,
    width: width
  }, void 0);
}